import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

export default function CustomLoader(props) {
  
  const handleClose = () => {
    props.setLoaderOpen(false);
  };
  const handleOpen = () => {
    props.setLoaderOpen(true);
  };

  return (
    <div> 
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.loaderOpen}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
